<template>
  <a v-if="configurationMode" :href="href" @click="onClick">
    <icon :name="name" />
  </a>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/lib/components/Shared/Icon.vue';

export default {
  components: {
    Icon
  },
  props: {
    name: {
      type: String,
      default: 'settings'
    },
    href: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('entryFormConfiguration', ['configurationMode'])
  },
  methods: {
    onClick(event) {
      if (this.href) {
        return;
      }

      event.preventDefault();

      this.$emit('clicked');
    }
  }
};
</script>

<style scoped>
a {
  padding: 0 5px;
}
</style>
